import { forwardRef } from 'react';
import { useForm } from './useForm';
import { getDisplayName } from '../../utils/helpers';
import { ContextProps } from './FormControlContext';

export const withForm = <P extends ContextProps>(WrappedComponent) => {
  const WithForm = forwardRef((props: P, ref) => {
    const formProps: ContextProps = useForm();

    return <WrappedComponent {...formProps} {...props} ref={ref} />;
  });

  WithForm.displayName = `withForm(${getDisplayName(WrappedComponent)})`;

  return WithForm;
};
